import { render, staticRenderFns } from "./washingFacilityPlanSafety.vue?vue&type=template&id=4bd14156"
import script from "./washingFacilityPlanSafety.vue?vue&type=script&lang=js"
export * from "./washingFacilityPlanSafety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd14156')) {
      api.createRecord('4bd14156', component.options)
    } else {
      api.reload('4bd14156', component.options)
    }
    module.hot.accept("./washingFacilityPlanSafety.vue?vue&type=template&id=4bd14156", function () {
      api.rerender('4bd14156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/wfp/washingFacilityPlanSafety.vue"
export default component.exports